import memberApi from '../../api/member.api'
import stateInfo from '../state'
const state = {
	highlyRecomData: [
		{
			type: '724web',
			class: 'icon_tool icon-724_logo',
			title: '智能营销建站神器',
			desc: '提供全行业网络营销建议方案，页面文字、图片灵活可视化...',
			href: 'https://www.nswyun.com/floor/Manager?goods_id=425&cat_id=216'
		},
		{
			type: 'yxyun',
			// class: 'icon_tool icon-custom_yun',
			title: '牛商营销云',
			desc: '牛商营销云-投排系统— 智能营销运营推广系统。让运营更简单、让推广更有效',
			href: 'https://www.nswyun.com/floor/ranking'
		},
		{
			type: 'jixun',
			class: 'icon_tool icon-jx_logo',
			title: '简单易用的小程序',
			desc: '一款可视化“拖拉拽”的小程序，全程无代码，小白也能...',
			href: 'https://www.nswyun.com/floor/ability'
		},
		{
			type: 'jiaye',
			class: 'icon_tool icon-jy_logo',
			title: '快速制作营销落地页',
			desc: '提升企业官网内页转化率的可视化自助制作工具。',
			href: 'http://jiaye.nsw88.com/#/'
		},

	],
	moreRecomData: [
		{
			type: 'shanxiu',
			class: 'icon_tool icon-sx_logo',
			title: '互联网移动营销神器',
			desc: '可以随时随地制作手机H5页面的神器，支持电脑和手机双端...',
			href: ''
		},
		{
			type: 'xuanwo',
			class: 'icon_tool icon-xw_logo',
			title: '网站营销力检测工具',
			desc: '一款支持网站营销力检测，敏感词检测的营销辅助工具。',
			href: 'https://www.xuanwo001.com/'
		},
		{
			type: 'handleOauth2gdj',
			class: 'icon_tool icon-gdj_logo',
			title: '用户运营管理系统',
			desc: '一款智能化的用户运营管理系统，从客服到业务的精细化管...',
			href: 'http://www.laile88.cn'
		},

		{
			type: 'meixiangdao',
			class: 'icon_tool icon-mxd_logo',
			title: '微信公众号增粉工具',
			desc: '一款低成本帮助企业公众号快速增长粉丝的裂变营销工具。',
			href: 'https://www.94mxd.com/home.html'
		},
		{
			type: 'chuangketie',
			class: 'icon_tool icon-ckt_logo',
			title: '极简的平面设计工具',
			desc: '简单三步，没有设计基础的小白也能制作出漂亮海报图片。',
			href: 'https://www.chuangkit.com/'
		},
		{
			type: 'baozhi',
			class: 'icon_tool icon-bz_logo',
			title: '微信群疯狂涨粉工具',
			desc: '通过微信社群，能够快速获取目标用户的微信群粉丝增长工具。',
			href: 'http://www.youdd.wang/case.html'
		},
		{
			type: 'baozhu',
			class: 'icon_tool icon-baoz_logo',
			title: '一站式软文发布平台',
			desc: '集合了上千家高质量软文发布平台，快速选取平台一键发布。',
			href: 'http://www.nsw88.com/baozhu.shtml'
		},
		{
			// 	type: 'handleKeyword',
			// 	class: 'icon_tool icon-keyword_logo',
			// 	title: '关键词生成工具',
			// 	desc: '根据企业特性，一键筛取行业关键词，提升网站竞争转化力。',
			// 	href: ''
			// }, {
			type: 'lianpu',
			class: 'icon_tool icon-lp_logo',
			title: '脸谱二维码',
			desc: '上传一张你喜欢的照片，生成一个与众不同的二维码。',
			href: ''
		},
		{
			type: 'handleMikecrm',
			class: 'icon_tool icon-mikecrm_logo',
			title: '可视化表单制作工具',
			desc: '适合小白的免费报名表单制作工具，简单6步即可完成。',
			href: 'http://v1.mikecrm.com/'
		},
		{
			type: 'handlepPyq',
			class: 'icon_tool icon-pyq_logo',
			title: '不折叠输入法',
			desc: '复制黏贴文字，发朋友圈总是折叠？这款输入法帮你多行展示。',
			href: 'http://zuimeia.com/app/6704/?category=4&platform=2'
		},

	],
	customData: [
		{
			type: 'pcSite',
			name: '营销型网站定制',
			class: 'icon_tool icon-custom_pc',
			desc: '锁定客户&nbsp;&nbsp;快速询盘',
			act: false,
			href: 'https://www.nsw88.com.cn/yxxwz.html'
		},
		{
			type: 'mcSite',
			class: 'icon_tool icon-custom_mc',
			name: '手机网站定制',
			desc: '专业的设计团队',
			act: false,
			href: 'https://www.nsw88.com.cn/mobile.html'
		},
		// {
		// 	type: 'yxYun',
		// 	class: 'icon_tool icon-custom_yun',
		// 	name: '营销云',
		// 	desc: '打造可靠的空间产品',
		// 	act: false,
		// 	href: 'https://www.nsw88.com.cn/yxy.html'
		// },
		{
			type: 'xcXu',
			class: 'icon_tool icon-custom_xu',
			name: '小程序定制开发',
			desc: '专业的产品研发团队',
			act: false,
			href: 'https://www.nsw88.com.cn/yxxxcx.html'
		},
		{
			type: 'dyYing',
			name: '孵化代运营',
			class: 'icon_tool icon-custom_ying',
			desc: '没团队照样可以接单',
			act: false,
			href: 'https://www.nsw88.com.cn/operatepc.html'
		},
		{
			type: 'ncEmail',
			class: 'icon_tool icon-custom_nc',
			name: 'NC企业邮箱',
			desc: '专业的商务沟通助手',
			act: false,
			href: 'https://www.nsw88.com.cn/qyyx.html'
		}
	]
}

const getters = {}

const mutations = {}

const actions = {
	oauth2Login (context, params) {
		return memberApi.oauth2Login(params)
	},
	async authorizeNewNSY ({ state }, params) {
		params.mobile = stateInfo.user.user.moblie
		const { data } = await memberApi.authorizeNewNSY(params)
		if (data.isSuccess) {
			return {
				isSuccess: true,
				nswUrl: data.data ? `${stateInfo.globals.nswUrl}?token=${data.data.token}` : ''
			}

		}
		return data
	}
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
